<ng-container *ngIf="!isAssetMixChart">
  <range-chart [rangeChartData]="actualChartData"></range-chart>
</ng-container>
<ng-container *ngIf="isAssetMixChart">
  <stacked-bar-chart [barChartData]="actualChartData" [isFullWidth]="true" [isPHC]="true"></stacked-bar-chart>
  <stacked-bar-chart [barChartData]="targetChartData" [isFullWidth]="true" [isPHC]="true"></stacked-bar-chart>
  <div class="asset-mix-view-choice">
    <c11n-radio-group [hideLegend]="true" [groupId]="'assetMixViewChoice'"
      (stateChange)="assetMixViewChoiceChangeHandler($event)">
      <div class="flex-row asset-mix-view-choice--label">
        <span>Show as:</span>
        <c11n-radio [labelText]="'Percent %'">
          <input c11nRadioInput id="asset-mix-view-choice-percent" type="radio" name="asset-mix-view-choice"
            value="percentage" [(ngModel)]="assetMixViewChoiceSelected" />
        </c11n-radio>
        <c11n-radio [labelText]="'Dollar $'">
          <input c11nRadioInput id="asset-mix-view-choice-dollar" type="radio" name="asset-mix-view-choice"
            value="currency" [(ngModel)]="assetMixViewChoiceSelected" />
        </c11n-radio>
      </div>
    </c11n-radio-group>
  </div>
</ng-container>

<table class="c11n-table c11n-table--small" [attr.aria-label]="isAssetMixChart ? 'Asset mix' : 'Global Stock exposure'">
  <thead>
    <tr class="c11n-table__tr">
      <th id="asset-type-header" scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left"
        [ngClass]="{'c11n-table__thead-th--max-width-178': !isAssetMixChart}">
        Asset Type
      </th>
      <th id="current-header" scope="col"
        class="c11n-table__thead-th c11n-table__thead-th--min-width-49 c11n-table__thead-th--align-right" [ngClass]="{
          'c11n-table__thead-th--min-width-49': isAssetMixChart? assetMixViewChoiceSelected === 'percentage' : true,
          'c11n-table__thead-th--min-width-76': isAssetMixChart? assetMixViewChoiceSelected === 'currency' : false
        }">
        Current
      </th>
      <th id="target-header" scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-right"
        *ngIf="isAssetMixChart" [ngClass]="{
          'c11n-table__thead-th--min-width-49': assetMixViewChoiceSelected === 'percentage',
          'c11n-table__thead-th--min-width-76': assetMixViewChoiceSelected === 'currency'
        }">
        Target
      </th>
      <th id="target-header" scope="col"
        class="c11n-table__thead-th c11n-table__thead-th--min-width-76 c11n-table__thead-th--align-right"
        *ngIf="!isAssetMixChart">
        Target range*
      </th>
      <th id="diff-header" scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-right"
        *ngIf="isAssetMixChart" [ngClass]="{
          'c11n-table__thead-th--min-width-49': assetMixViewChoiceSelected === 'percentage',
          'c11n-table__thead-th--min-width-76': assetMixViewChoiceSelected === 'currency'
        }">
        Diff.
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="!isAssetMixChart">
      <tr *ngFor="let actualChartDataSlice of actualChartData.chartSlices; let myIndex = index"
        class="c11n-table__tr-content">
        <th scope="row" id="asset-type-header"
          class="c11n-table__thead-th c11n-table__thead-th--max-width-178 c11n-table__thead-th--align-left c11n-table__thead-td">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="15" height="15" [attr.fill]="actualChartDataSlice.color" stroke="white" />
          </svg>
          <span>{{ actualChartDataSlice.label }}</span>
        </th>
        <td id="current-header"
          class="c11n-table__thead-th c11n-table__thead-th--min-width-49 c11n-table__thead-th--align-right c11n-table__thead-td">
          {{ actualChartDataSlice.value }}%
        </td>
        <td id="target-header"
          class="c11n-table__thead-th c11n-table__thead-th--min-width-76 c11n-table__thead-th--align-right c11n-table__thead-td">
          <ng-container *ngIf="actualChartDataSlice.range.length">
            {{ actualChartDataSlice.range[0] }}%-{{ actualChartDataSlice.range[1] }}%
          </ng-container>
          <ng-container *ngIf="!actualChartDataSlice.range.length"> - </ng-container>
        </td>
      </tr>
    </ng-container>
    <ng-container *ngIf="isAssetMixChart">
      <tr *ngFor="let actualChartDataSlice of actualChartData.chartSlices; let myIndex = index" scope="row"
        class="c11n-table__tr-content">
        <th scope="row" id="asset-type-body"
          class="c11n-table__thead-th c11n-table__thead-th--align-left c11n-table__thead-td">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="15" height="15" attr.fill="{{ actualChartDataSlice.color }}" stroke="white" />
          </svg>
          <span>{{ actualChartDataSlice.label }}</span>
        </th>
        <td id="current-body" scope="col"
          class="c11n-table__thead-th c11n-table__thead-th--align-right c11n-table__thead-td" [ngClass]="{
            'c11n-table__thead-th--min-width-49': assetMixViewChoiceSelected === 'percentage',
            'c11n-table__thead-th--min-width-76': assetMixViewChoiceSelected === 'currency'
          }">
          {{ formatValues(actualChartDataSlice.value) }}
        </td>
        <td id="target-body" scope="col"
          class="c11n-table__thead-th c11n-table__thead-th--align-right c11n-table__thead-td" [ngClass]="{
            'c11n-table__thead-th--min-width-49': assetMixViewChoiceSelected === 'percentage',
            'c11n-table__thead-th--min-width-76': assetMixViewChoiceSelected === 'currency'
          }">
          {{ formatValues(targetChartData.chartSlices[myIndex].value) }}
        </td>
        <td id="diff-body" scope="col"
          class="c11n-table__thead-th c11n-table__thead-th--align-right c11n-table__thead-td" [ngClass]="{
            'c11n-table__thead-th--min-width-49': assetMixViewChoiceSelected === 'percentage',
            'c11n-table__thead-th--min-width-76': assetMixViewChoiceSelected === 'currency'
          }">
          {{ formatValues(actualChartDataSlice.value - targetChartData.chartSlices[myIndex].value) }}
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>